import { NetworkStatus, useQuery } from '@apollo/client';
import { Grid } from '@mui/material';
import Evaluation1Table from 'components/Tables/Evaluation1';
import LoadingIndicator from 'components/LoadingIndicator';
import Navbar from 'components/Navbar';
import UsersTable from 'components/Tables/Users';
import {
  GET_USER_BY_ID_QUERY,
  GET_USER_GOALS,
  GetUserByIdResponse,
  GetUserByIdVariables,
  GetUserGoalsResponse,
  GetUserGoalsVariables,
} from 'graphql/query/user';
import { useParams } from 'react-router-dom';
import Evaluation2Table from 'components/Tables/Evaluation2';
import QnASection from 'components/QnA/QnASection';
import { RecommendedForPromotionEnum, User } from 'types';
import Evaluation3Table from 'components/Tables/Evaluation3';
import { getSelectedObjectiveGoalsYear } from 'utils/common';

const ReporteeDetailsPage = () => {
  const { userId = '' } = useParams<{ userId: string }>();

  const { data: userGoals, networkStatus: userGoalsNetworkStatus } = useQuery<
    GetUserGoalsResponse,
    GetUserGoalsVariables
  >(GET_USER_GOALS, {
    variables: {
      user: userId,
      year: getSelectedObjectiveGoalsYear(),
    },
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  });

  const { data: user, networkStatus: userNetworkStatus } = useQuery<
    GetUserByIdResponse,
    GetUserByIdVariables
  >(GET_USER_BY_ID_QUERY, {
    variables: {
      user: userId,
      year: getSelectedObjectiveGoalsYear(),
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
  });

  const loadingUser = userNetworkStatus === NetworkStatus.loading || !!!user;
  const loadingUserGoals = userGoalsNetworkStatus === NetworkStatus.loading || !!!userGoals;
  const isRunningYear = new Date().getFullYear() === getSelectedObjectiveGoalsYear();

  return (
    <Navbar
      goBackButtonConfig={{
        title: `Reportee Details - ${getSelectedObjectiveGoalsYear()}`,
      }}
    >
      {loadingUser || loadingUserGoals ? (
        <LoadingIndicator />
      ) : (
        <Grid container direction="column" rowGap={2} mb={3}>
          <Evaluation1Table
            employee={user.getUserById}
            title={`${user.getUserById.name}'s Objective Settings`}
            initialRows={!!userGoals.getUserGoals?.length ? userGoals.getUserGoals : undefined}
          />
          {(!isRunningYear ||
            ((user?.getUserById.annualUserInfo?.period as number) > 1 &&
              !!userGoals.getUserGoals?.length)) && (
            <Evaluation2Table
              employee={user.getUserById}
              title={`${user.getUserById.name}'s Mid Year Review`}
              initialRows={!!userGoals.getUserGoals?.length ? userGoals.getUserGoals : undefined}
            />
          )}

          {(!isRunningYear ||
            ((user?.getUserById.annualUserInfo?.period as number) > 2 &&
              !!userGoals.getUserGoals?.length)) && (
            <Evaluation3Table
              employee={user.getUserById as User}
              title={`${user.getUserById.name}'s End Year Review`}
              initialRows={!!userGoals.getUserGoals?.length ? userGoals.getUserGoals : undefined}
            />
          )}

          {user?.getUserById?.annualUserInfo?.isRecommendedForPromotion ===
            RecommendedForPromotionEnum.YES && <QnASection employee={user.getUserById as User} />}

          {!!(user?.getUserById?.reportees ?? []).length && (
            <UsersTable
              rows={user.getUserById.reportees}
              title={`${user.getUserById.name}'s Reportees`}
            />
          )}
        </Grid>
      )}
    </Navbar>
  );
};

export default ReporteeDetailsPage;
